import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { User, UserInput } from '../types/teamTypes';

/** Team members (API: /users). Owner only, except the pickers. */
export const teamService = {
  ...crudService<User, UserInput>('/users'),
  resetPassword: (id: string, password: string) => api.post(`/users/${id}/reset-password`, { password }),
  /** Quick search for pickers. */
  search: (search: string, query: Record<string, string> = {}) => api.get('/users', { search, limit: 20, ...query }).then((r) => r.data as User[]),
};
